
import Vue from 'vue'
import { VBtn, VTextField } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcTestingModal',
  components: {
    VBtn,
    VTextField,
  },
  props: {
    loggedIn: { type: Boolean, default: undefined },
    userInfo: { type: String, default: '' },
    entraUser: { type: String, default: '' },
    appEnvironment: { type: String, default: 'production' },
  },
  data() {
    return {
      displayTestingPanel: true,
      adNameTest: '',
    }
  },
})
